module.exports = __webpack_public_path__ + "img/oneup-headshot.ed0fb073.png";